import React, { Component } from 'react'
import { connect } from 'react-redux'
import { StyledSection, StyledRow, SumbitError } from './oForm.style'
import { getKey, validateFields } from '../../../utils'
import {
  Breakpoints,
  Layout,
  LayoutRowGap,
  Text,
  TextAreaAppearance,
  TextColor,
  TextInputAppearance,
  Fieldset,
  Button,
  ButtonAppearance,
  RadioButton,
  FieldsetAppearance,
  Checkbox
} from '@volkswagen-onehub/components-core'
import FormContainer from 'form/components/molecules/mFormContainer'
import {
  TEXT_INPUT_DYNAMIC_TEXT,
  TEXT_INPUT_DYNAMIC_EMAIL,
  TEXT_INPUT_DYNAMIC_PHONE,
  TEXT_INPUT_DYNAMIC_CAR_REG,
  TEXT_INPUT_DYNAMIC_AREA,
  TEXT_INPUT_DYNAMIC_POSTCODE,
  DROP_DOWN
} from 'form/store/form/constants.js'
import TextInputDynamic from 'form/components/molecules/mTextInputDynamic'
import TextWithTooltip from 'form/components/molecules/mTextWithTooltip'
import GoogleAddress from 'form/components/molecules/mGoogleAddress'
import HTMLSelect from 'form/components/molecules/mHTMLSelect'
import {
  firePageIsLoading,
  fireSubmitIsClicked,
  fireSubmitError
} from 'form/services'
import {
  UNSET,
  VALID,
  INVALID,
  ADDRESS_FINDER
} from 'form/store/form/constants'
import * as formActions from 'form/store/form/actions'

class Form extends Component {
  componentDidMount() {
    const { fields, createFormElements, vehicleId } = this.props
    createFormElements(fields)
    firePageIsLoading(vehicleId)
  }
  createRadioGroup = (legend, error, list, name) => {
    return (
      <>
        <Fieldset
          key={name}
          legend={legend}
          appearance={this.getRadioStyle(name)}
          errorText={error}
        >
          <Layout
            key={name}
            rowGap={
              list.length < 3 ? LayoutRowGap.static000 : LayoutRowGap.static400
            }
            appearance={{
              [Breakpoints.default]: [
                { name: 'a', columns: 12 },
                { name: 'b', columns: 12 },
                { name: 'c', columns: 12 },
                { name: 'd', columns: 12 }
              ],
              [Breakpoints.tablet]: [
                { name: 'a', columns: 5 },
                { name: '.', columns: 2 },
                { name: 'b', columns: 5 },
                { name: '.', columns: 1 },
                { name: 'c', columns: 5 },
                { name: '.', columns: 1 },
                { name: 'd', columns: 5 }
              ]
            }}
          >
            {list.map(field => (
              <RadioButton
                key={getKey()}
                name={name}
                value={field.value}
                label={field.label}
                checked={this.isRadioChecked(field.value, name)}
                onClick={e => this.handleRadioClick(e, name)}
              />
            ))}
          </Layout>
        </Fieldset>
      </>
    )
  }
  createDynamicCheckboxWithLegend = (legend, field, name) => {
    const k = getKey()
    return (
      <Fieldset key={name} legend={legend}>
        {this.createCheckbox(field, name, k)}
      </Fieldset>
    )
  }
  getInputStyle = (key, type) => {
    const { initialised, formData, showUserErrors } = this.props
    let style =
      type === TEXT_INPUT_DYNAMIC_AREA
        ? TextAreaAppearance.Default
        : TextInputAppearance.Default
    if (
      showUserErrors &&
      formData[key].required &&
      (formData[key].valid === INVALID || formData[key].valid === UNSET)
    ) {
      style =
        type === TEXT_INPUT_DYNAMIC_AREA
          ? TextAreaAppearance.Error
          : TextInputAppearance.Error
    } else if (initialised && formData[key].valid === INVALID) {
      style =
        type === TEXT_INPUT_DYNAMIC_AREA
          ? TextAreaAppearance.Error
          : TextInputAppearance.Error
    }
    return style
  }
  getRadioStyle = key => {
    const { initialised, formData, showUserErrors } = this.props
    let style = FieldsetAppearance.Default
    if (
      showUserErrors &&
      (formData[key].valid === INVALID || formData[key].valid === UNSET)
    ) {
      style = FieldsetAppearance.Error
    } else if (initialised && formData[key].valid === INVALID) {
      style = FieldsetAppearance.Error
    }
    return style
  }

  getRenderItem = field => {
    const { setFormElement } = this.props
    const key = field.name
    if (field.isText) {
      return (
        <TextWithTooltip
          key={getKey()}
          textTag={field.textTag}
          textAppearance={field.textAppearance}
          isRichText={field.isRichText}
          hasTooltip={field.hasTooltip}
          text={field.text}
          tooltipText={field.tooltipText}
        />
      )
    } else if (field.isDropDown) {
      return (
        <HTMLSelect
          key={getKey()}
          cmsData={field}
          getInputStyle={this.getInputStyle(field.name, DROP_DOWN)}
          selectedValue={this.getSelectedDropDownValue(field.name)}
          setFormElement={setFormElement}
        />
      )
    } else if (
      field.isTextInput ||
      field.isCarRegInput ||
      field.isPhoneInput ||
      field.isEmailInput ||
      field.isPostcode ||
      field.isTextArea
    ) {
      let type = TEXT_INPUT_DYNAMIC_TEXT
      if (field.isPhoneInput) {
        type = TEXT_INPUT_DYNAMIC_PHONE
      } else if (field.isCarRegInput) {
        type = TEXT_INPUT_DYNAMIC_CAR_REG
      } else if (field.isEmailInput) {
        type = TEXT_INPUT_DYNAMIC_EMAIL
      } else if (field.isTextArea) {
        type = TEXT_INPUT_DYNAMIC_AREA
      } else if (field.isPostcode) {
        type = TEXT_INPUT_DYNAMIC_POSTCODE
      }
      return (
        <FormContainer key={key}>
          {this.createTextInput(type, field, key)}
        </FormContainer>
      )
    } else if (field.isRadio) {
      return this.createRadioGroup(
        field.legend,
        field.error,
        field.options,
        key
      )
    } else if (field.isCheckBox) {
      if (field.legend) {
        return this.createDynamicCheckboxWithLegend(field.legend, field, key)
      } else {
        return this.createCheckbox(field, key)
      }
    } else if (field.isGoogleAddress) {
      const {
        setGoogleAddressIsOpenTo,
        formData,
        googleAddressIsNeeded,
        googleAddressIsOpen
      } = this.props
      return (
        <GoogleAddress
          key={key}
          cmsData={field}
          formData={formData}
          getInputStyle={this.getInputStyle}
          googleAddressIsNeeded={googleAddressIsNeeded}
          googleAddressIsOpen={googleAddressIsOpen}
          setFormElement={setFormElement}
          setGoogleAddressIsOpenTo={setGoogleAddressIsOpenTo}
        />
      )
    }
  }
  getAllItemsWithinRow = row => {
    const list = []
    for (let i = 0; i < row.length; i++) {
      list.push(this.getRenderItem(row[i]))
    }
    return list
  }
  createTextInput = (type, field, key) => {
    return (
      <TextInputDynamic
        key={key}
        type={type}
        cmsData={field}
        getInputStyle={key => this.getInputStyle(key, type)}
        handleInputChange={e => this.handleInputChange(e, field)}
      />
    )
  }
  createCheckbox = (field, key) => {
    return (
      <Checkbox
        key={key}
        value={field.value}
        label={field.label}
        onClick={e => this.handleCheckboxChange(e, field)}
        required={field.required}
        errorText={field.error}
      />
    )
  }
  isRadioChecked = (value, name) => {
    const { initialised, formData } = this.props
    if (!initialised) {
      return ''
    }
    return formData[name].value === value
  }
  getSelectedDropDownValue = name => {
    const { initialised, formData } = this.props
    if (!initialised) {
      return ''
    }
    return formData[name].value
  }
  isGoogleAddress = key => {
    const { googleAddressFields } = this.props
    if (key === ADDRESS_FINDER) {
      return true
    }
    for (var i = 0; i < googleAddressFields.length; i++) {
      if (googleAddressFields[i] === key) {
        return true
      }
    }
    return false
  }

  handleSubmit = () => {
    const {
      apis,
      formData,
      sendForm,
      buttonText,
      vehicleId,
      campaignCode,
      updateFormErrors,
      setShowUserErrors,
      rows
    } = this.props

    setShowUserErrors(true)

    const failed = updateFormErrors()
    const dontUseGlobalVehicleId =
      formData.vehicleId && formData.vehicleId.value
    let vehicleLabel = ''
    if (dontUseGlobalVehicleId) {
      rows.map((row, index) => {
        row.items.map((item, i) => {
          if (item.name === 'vehicleId') {
            const list = item.options.filter(option => {
              if (option.value === formData.vehicleId.value) {
                return option
              }
              return false
            })
            if (list.length > 0) {
              vehicleLabel = list[0].label
            }
          }
        })
      })
    }
    const formVehicleId = dontUseGlobalVehicleId
      ? formData.vehicleId.value
      : vehicleId
    const customerType = formData.customerType
      ? formData.customerType.value.toUpperCase()
      : 'PRIVATE'
    const marketingConsent = formData.optin
      ? formData.optin.value.replace('optin', '')
      : 'Email'
    const enquiryType = formData.enquiryType ? formData.enquiryType.value : null
    if (!failed) {
      fireSubmitIsClicked(
        buttonText,
        formVehicleId,
        vehicleLabel,
        customerType,
        marketingConsent,
        enquiryType
      )
      sendForm(apis, formVehicleId, vehicleLabel, campaignCode)
    } else {
      const errors = []
      Object.entries(formData).forEach(([key, value]) => {
        if (value.valid !== VALID) {
          errors.push({
            'form field id': value.valid,
            'form field name': key
          })
        }
      })
      fireSubmitError(
        errors,
        buttonText,
        formVehicleId,
        vehicleLabel,
        customerType,
        marketingConsent
      )
    }
  }
  handleRadioClick = (event, name) => {
    const { setFormElement } = this.props
    const isValid =
      event.currentTarget.value === '' || event.currentTarget.value === 'false'
        ? INVALID
        : VALID
    setFormElement(name, {
      value: event.currentTarget.value,
      valid: isValid
    })
  }
  handleCheckboxChange = (e, field) => {
    const { setFormElement } = this.props
    setFormElement(field.name, {
      value: field.value,
      valid: e.target.checked ? VALID : INVALID
    })
  }
  handleTextAreaChange = (e, field) => {
    const { setFormElement } = this.props
    setFormElement(field.name, {
      value: e.target.value,
      valid: e.target.value === '' ? INVALID : VALID
    })
  }
  handleInputChange = (e, field) => {
    const { setFormElement } = this.props
    const valid = validateFields(field, e.target.value) ? VALID : INVALID
    setFormElement(field.name, {
      value: e.target.value,
      valid: e.target.value === '' ? UNSET : valid
    })
  }
  render() {
    const { buttonText, buttonErrorText, rows, showUserErrors } = this.props
    return (
      <StyledSection>
        <Layout
          rowGap={LayoutRowGap.static000}
          appearance={{
            [Breakpoints.default]: [{ name: 'a', columns: 24 }]
          }}
        >
          {rows.map((currentRow, index) => (
            <StyledRow
              key={index}
              className="styled-row"
              marginTop={currentRow.topMargin}
              marginBottom={currentRow.bottomMargin}
            >
              <Layout
                rowGap={LayoutRowGap.static000}
                appearance={
                  currentRow.items.length > 1
                    ? {
                        [Breakpoints.default]: [
                          { name: 'a', columns: 24 },
                          { name: 'b', columns: 24 },
                          { name: 'c', columns: 24 }
                        ],
                        [Breakpoints.b960]: [
                          { name: 'a', columns: 11 },
                          { name: '.', columns: 2 },
                          { name: 'b', columns: 11 }
                        ]
                      }
                    : {
                        [Breakpoints.default]: [
                          { name: 'a', columns: 24 },
                          { name: 'b', columns: 24 },
                          { name: 'c', columns: 24 }
                        ]
                      }
                }
              >
                {currentRow.items.map((element, i) => (
                  <div key={i}>
                    {element && element.name && (
                      <>{this.getRenderItem(element)}</>
                    )}
                  </div>
                ))}
              </Layout>
            </StyledRow>
          ))}

          <FormContainer>
            <Button
              appearance={ButtonAppearance.Primary}
              onClick={this.handleSubmit}
            >
              <Text tag="h2" color={TextColor.inherit}>
                {buttonText}
              </Text>
            </Button>
            {showUserErrors && (
              <SumbitError className="submit-error">
                <Text tag="p" color={TextColor.secondary}>
                  {buttonErrorText}
                </Text>
              </SumbitError>
            )}
          </FormContainer>
        </Layout>
      </StyledSection>
    )
  }
}

const mapStateToProps = ({
  page: { cmsdata },
  form: {
    initialised,
    showUserErrors,
    googleAddressIsNeeded,
    formContainsErrors,
    hasMarketingConsentPost,
    googleAddressIsOpen,
    googleAddressFields,
    formData,
    rows
  }
}) => {
  const { form } = cmsdata.data.pages.homePage
  const { apis, vehicleId, campaignCode } = cmsdata.data.globals

  const { buttonText, buttonErrorText, fields } = form

  return {
    formData,
    rows,
    initialised,
    showUserErrors,
    googleAddressIsNeeded,
    formContainsErrors,
    googleAddressIsOpen,
    googleAddressFields,
    hasMarketingConsentPost,
    apis,
    vehicleId,
    campaignCode,
    buttonText,
    buttonErrorText,
    fields
  }
}

export default connect(mapStateToProps, formActions)(Form)
